/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Abandonsession1Inputs */
/** @typedef {{}} Abandonsessioncancel2Inputs */
/** @typedef {{}} Abandonsessionconfirm2Inputs */
/** @typedef {{}} Abandonsessionconfirmaction3Inputs */
/** @typedef {{}} Accountaccessdenied2Inputs */
/** @typedef {{}} Agentbusy1Inputs */
/** @typedef {{ count: NonNullable<unknown> }} Agenthostbusymany3Inputs */
/** @typedef {{}} Agenthostbusyone3Inputs */
/** @typedef {{}} Agentmodel1Inputs */
/** @typedef {{}} Agentmodelhint2Inputs */
/** @typedef {{}} Agentname1Inputs */
/** @typedef {{}} Agentstatus1Inputs */
/** @typedef {{}} Agentthinking1Inputs */
/** @typedef {{}} Agentworking1Inputs */
/** @typedef {{}} Apicallfailed2Inputs */
/** @typedef {{}} Apiunreachable1Inputs */
/** @typedef {{}} Appssectionlabel2Inputs */
/** @typedef {{}} Attachfiles1Inputs */
/** @typedef {{}} Automationscanceledit2Inputs */
/** @typedef {{}} Automationscreate1Inputs */
/** @typedef {{}} Automationscreateheading2Inputs */
/** @typedef {{}} Automationsdelete1Inputs */
/** @typedef {{}} Automationsdisable1Inputs */
/** @typedef {{}} Automationsdisabled1Inputs */
/** @typedef {{}} Automationsedit1Inputs */
/** @typedef {{}} Automationsempty1Inputs */
/** @typedef {{}} Automationsenable1Inputs */
/** @typedef {{}} Automationsenabled1Inputs */
/** @typedef {{}} Automationsfieldcron2Inputs */
/** @typedef {{}} Automationsfieldparentsession3Inputs */
/** @typedef {{}} Automationsfieldprompt2Inputs */
/** @typedef {{}} Automationsfieldproposemr3Inputs */
/** @typedef {{}} Automationsfieldtitle2Inputs */
/** @typedef {{}} Automationsgroupsheading2Inputs */
/** @typedef {{ status: NonNullable<unknown>, summary: NonNullable<unknown> }} Automationslatestrun2Inputs */
/** @typedef {{}} Automationslead1Inputs */
/** @typedef {{}} Automationsnav1Inputs */
/** @typedef {{}} Automationsnoparentsessions3Inputs */
/** @typedef {{}} Automationsopensession2Inputs */
/** @typedef {{}} Automationsreadonly2Inputs */
/** @typedef {{}} Automationsrunnow2Inputs */
/** @typedef {{}} Automationssave1Inputs */
/** @typedef {{}} Automationstitle1Inputs */
/** @typedef {{}} Brandlogoalt2Inputs */
/** @typedef {{}} Browserlivepreview2Inputs */
/** @typedef {{}} Browserlivepreviewalt3Inputs */
/** @typedef {{}} Browserlivepreviewhide3Inputs */
/** @typedef {{}} Browserlivepreviewshow3Inputs */
/** @typedef {{}} Capturepreview1Inputs */
/** @typedef {{}} Capturepreviewfailed2Inputs */
/** @typedef {{}} Capturepreviewhint2Inputs */
/** @typedef {{}} Capturepreviewunavailable2Inputs */
/** @typedef {{}} Captureselectionhint2Inputs */
/** @typedef {{}} Captureselectionunavailable2Inputs */
/** @typedef {{}} Changetarget1Inputs */
/** @typedef {{}} Chatregion1Inputs */
/** @typedef {{}} Chattitle1Inputs */
/** @typedef {{}} Closeconversationhistory2Inputs */
/** @typedef {{}} Collapsechat1Inputs */
/** @typedef {{}} Collapseconversationrail2Inputs */
/** @typedef {{}} Continuelastappaction3Inputs */
/** @typedef {{}} Continuelastappbadge3Inputs */
/** @typedef {{}} Continuelastappdescription3Inputs */
/** @typedef {{}} Continuelastappsectionlabel4Inputs */
/** @typedef {{}} Conversationhistory1Inputs */
/** @typedef {{}} Conversationhistoryempty2Inputs */
/** @typedef {{}} Conversationrail1Inputs */
/** @typedef {{}} Conversationrailmineempty3Inputs */
/** @typedef {{}} Conversationrailshowall3Inputs */
/** @typedef {{}} Conversationrailshowmine3Inputs */
/** @typedef {{}} Copylink1Inputs */
/** @typedef {{}} Defaultindependentappaction3Inputs */
/** @typedef {{}} Defaultindependentappbadge3Inputs */
/** @typedef {{}} Deletescratchappaction3Inputs */
/** @typedef {{}} Deletescratchappcancel3Inputs */
/** @typedef {{}} Deletescratchappconfirmaction4Inputs */
/** @typedef {{ label: NonNullable<unknown> }} Deletescratchappconfirmlead4Inputs */
/** @typedef {{}} Deletescratchappconfirmtitle4Inputs */
/** @typedef {{}} Deletescratchappworking3Inputs */
/** @typedef {{}} Deploycancelaction2Inputs */
/** @typedef {{}} Deployconfirmaction2Inputs */
/** @typedef {{}} Deploymodedialogtitle3Inputs */
/** @typedef {{}} Deploymodenewapp3Inputs */
/** @typedef {{}} Deploymodereplaceparent3Inputs */
/** @typedef {{}} Deploymodethisapp3Inputs */
/** @typedef {{}} Deploynewsluglabel3Inputs */
/** @typedef {{}} Deploynewslugplaceholder3Inputs */
/** @typedef {{ url: NonNullable<unknown> }} Deploypublicurlhint3Inputs */
/** @typedef {{}} Deploysessionaction2Inputs */
/** @typedef {{ hostname: NonNullable<unknown> }} Deploysessionsucceeded2Inputs */
/** @typedef {{}} Deploysessionworking2Inputs */
/** @typedef {{}} Deploysluginvalidhint3Inputs */
/** @typedef {{}} Deployslugreservedhint3Inputs */
/** @typedef {{}} Deployslugtakenhint3Inputs */
/** @typedef {{}} Deployedappeditaction3Inputs */
/** @typedef {{}} Deployedappopenaction3Inputs */
/** @typedef {{}} Deployedapprevertaction3Inputs */
/** @typedef {{}} Deployedapprevertcancel3Inputs */
/** @typedef {{}} Deployedapprevertconfirm3Inputs */
/** @typedef {{}} Deployedapprevertdialogtitle4Inputs */
/** @typedef {{}} Deployedapprevertempty3Inputs */
/** @typedef {{}} Deployedapprevertworking3Inputs */
/** @typedef {{}} Deployedappstopaction3Inputs */
/** @typedef {{}} Deployedappsempty2Inputs */
/** @typedef {{}} Deployedappssectionlabel3Inputs */
/** @typedef {{}} Dictatemessage1Inputs */
/** @typedef {{}} Dictationunsupported1Inputs */
/** @typedef {{ fileName: NonNullable<unknown> }} Downloadattachment1Inputs */
/** @typedef {{}} Expandchat1Inputs */
/** @typedef {{}} Expandconversationrail2Inputs */
/** @typedef {{}} Favoritebadge1Inputs */
/** @typedef {{}} Favoriteopenaction2Inputs */
/** @typedef {{}} Favoritesempty1Inputs */
/** @typedef {{}} Favoritessectionlabel2Inputs */
/** @typedef {{}} Homelead1Inputs */
/** @typedef {{}} Identityproviderunavailable2Inputs */
/** @typedef {{}} Independentappssectionempty3Inputs */
/** @typedef {{}} Independentappssectionlabel3Inputs */
/** @typedef {{}} Inspecthint1Inputs */
/** @typedef {{ messageKey: NonNullable<unknown>, filePart: NonNullable<unknown>, textPart: NonNullable<unknown> }} Inspectselectionwithkey3Inputs */
/** @typedef {{}} Inspectselectionsheader2Inputs */
/** @typedef {{}} Linkcopied1Inputs */
/** @typedef {{}} Lintfailed1Inputs */
/** @typedef {{}} Loadingsession1Inputs */
/** @typedef {{}} LoginInputs */
/** @typedef {{}} Logininstructions1Inputs */
/** @typedef {{}} Logintitle1Inputs */
/** @typedef {{}} LogoutInputs */
/** @typedef {{}} Maximizechat1Inputs */
/** @typedef {{}} Mergerequestopened2Inputs */
/** @typedef {{}} Mergerequestupdated2Inputs */
/** @typedef {{}} Messageplaceholder1Inputs */
/** @typedef {{}} Missingrootelement2Inputs */
/** @typedef {{}} Newconversation1Inputs */
/** @typedef {{}} Newscratchappaction3Inputs */
/** @typedef {{}} Newscratchappcancel3Inputs */
/** @typedef {{}} Newscratchappcreating3Inputs */
/** @typedef {{}} Newscratchappdescription3Inputs */
/** @typedef {{}} Newscratchapplabel3Inputs */
/** @typedef {{}} Newscratchappnamelabel4Inputs */
/** @typedef {{}} Newscratchappnameplaceholder4Inputs */
/** @typedef {{ slug: NonNullable<unknown> }} Newscratchappslughint4Inputs */
/** @typedef {{}} Newscratchappsluginvalid4Inputs */
/** @typedef {{}} Openmergerequest2Inputs */
/** @typedef {{}} Openspecarchivemergerequestopened4Inputs */
/** @typedef {{}} Pagetitle1Inputs */
/** @typedef {{}} Pinfavorite1Inputs */
/** @typedef {{}} Previewdevicedesktop2Inputs */
/** @typedef {{}} Previewdevicemobile2Inputs */
/** @typedef {{}} Previewdeviceswitch2Inputs */
/** @typedef {{}} Previewdevicetablet2Inputs */
/** @typedef {{}} Previewoff1Inputs */
/** @typedef {{}} Previewpathapply2Inputs */
/** @typedef {{}} Previewpathback2Inputs */
/** @typedef {{}} Previewpathforward2Inputs */
/** @typedef {{}} Previewpathinvalid2Inputs */
/** @typedef {{}} Previewpathlabel2Inputs */
/** @typedef {{}} Previewpathofforigin3Inputs */
/** @typedef {{}} Previewpathpresetcatalogue3Inputs */
/** @typedef {{}} Previewpathpresetdiaporama3Inputs */
/** @typedef {{}} Previewpathpresethome3Inputs */
/** @typedef {{}} Previewpathpresets2Inputs */
/** @typedef {{}} Previewregion1Inputs */
/** @typedef {{}} Previewrestoring1Inputs */
/** @typedef {{}} Promptactivityclose2Inputs */
/** @typedef {{}} Promptactivityempty2Inputs */
/** @typedef {{}} Promptactivitylead2Inputs */
/** @typedef {{}} Promptactivityloadfailed3Inputs */
/** @typedef {{}} Promptactivitytitle2Inputs */
/** @typedef {{}} Promptactivityuntitled2Inputs */
/** @typedef {{}} Quickstartaction2Inputs */
/** @typedef {{}} Quickstartlabel2Inputs */
/** @typedef {{}} Quickstartnostartertarget4Inputs */
/** @typedef {{}} Quickstartplaceholder2Inputs */
/** @typedef {{}} Quickstartworking2Inputs */
/** @typedef {{}} Redeploysessionaction2Inputs */
/** @typedef {{ fileName: NonNullable<unknown> }} Removeattachment1Inputs */
/** @typedef {{ label: NonNullable<unknown> }} Removeselection1Inputs */
/** @typedef {{}} Renameconversation1Inputs */
/** @typedef {{}} Requestrequired1Inputs */
/** @typedef {{}} Resizechat1Inputs */
/** @typedef {{}} Restorechat1Inputs */
/** @typedef {{}} Saveconversationtitle2Inputs */
/** @typedef {{}} Securespace1Inputs */
/** @typedef {{}} Selectcomponent1Inputs */
/** @typedef {{}} Sendmessage1Inputs */
/** @typedef {{}} Servicetemporarilyunavailable2Inputs */
/** @typedef {{}} Sessionaccessdenied2Inputs */
/** @typedef {{}} Sessionaccessdeniedlead3Inputs */
/** @typedef {{}} Sessionloading1Inputs */
/** @typedef {{}} Sessionmakeopen2Inputs */
/** @typedef {{}} Sessionmakeprivate2Inputs */
/** @typedef {{}} Sessionmissing1Inputs */
/** @typedef {{}} Sessionpublishmenu2Inputs */
/** @typedef {{}} Sessionshareadd2Inputs */
/** @typedef {{}} Sessionshareemailplaceholder3Inputs */
/** @typedef {{}} Sessionsharedwithyou3Inputs */
/** @typedef {{}} Sessionsharing1Inputs */
/** @typedef {{}} Sessionunshare1Inputs */
/** @typedef {{ email: NonNullable<unknown> }} Sessionunshareemail2Inputs */
/** @typedef {{}} Sessionvisibilityopen2Inputs */
/** @typedef {{}} Sessionvisibilityprivate2Inputs */
/** @typedef {{}} SettingsInputs */
/** @typedef {{}} Settingsclose1Inputs */
/** @typedef {{}} Settingscreateappheading3Inputs */
/** @typedef {{}} Settingscreateapplead3Inputs */
/** @typedef {{}} Settingscreateappsubtitle3Inputs */
/** @typedef {{}} Settingscreateapptoggle3Inputs */
/** @typedef {{}} Settingsdeleteappheading3Inputs */
/** @typedef {{}} Settingsdeleteapplead3Inputs */
/** @typedef {{}} Settingsdeleteappsubtitle3Inputs */
/** @typedef {{}} Settingsdeleteapptoggle3Inputs */
/** @typedef {{}} Settingseyebrow1Inputs */
/** @typedef {{}} Settingspreviewpathbarheading4Inputs */
/** @typedef {{}} Settingspreviewpathbarlead4Inputs */
/** @typedef {{}} Settingspreviewpathbarsubtitle4Inputs */
/** @typedef {{}} Settingspreviewpathbartoggle4Inputs */
/** @typedef {{}} Settingspromptactivityheading3Inputs */
/** @typedef {{}} Settingspromptactivitylead3Inputs */
/** @typedef {{}} Settingspromptactivitysubtitle3Inputs */
/** @typedef {{}} Settingspromptactivitytoggle3Inputs */
/** @typedef {{}} Settingstitle1Inputs */
/** @typedef {{}} Sourceconnectaction2Inputs */
/** @typedef {{}} Sourceconnectconnecting2Inputs */
/** @typedef {{}} Sourceconnectopenviewer3Inputs */
/** @typedef {{}} Sourceconnectskip2Inputs */
/** @typedef {{}} Sourceconnecttitle2Inputs */
/** @typedef {{}} Startpreview1Inputs */
/** @typedef {{}} Startsectionlabel2Inputs */
/** @typedef {{}} Startsectionlead2Inputs */
/** @typedef {{}} Startsectiontitle2Inputs */
/** @typedef {{}} Startingrequest1Inputs */
/** @typedef {{}} Stopdictation1Inputs */
/** @typedef {{}} Stopselectingcomponent2Inputs */
/** @typedef {{}} Stopturn1Inputs */
/** @typedef {{}} Studioname1Inputs */
/** @typedef {{}} Studiowelcomeeyebrow2Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleattack3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleembellish3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitlehello3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleidea3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleimprove3Inputs */
/** @typedef {{}} Syncsessionbase2Inputs */
/** @typedef {{}} Targetopenaction2Inputs */
/** @typedef {{}} Targetpickerempty2Inputs */
/** @typedef {{}} Targetpickerlead2Inputs */
/** @typedef {{ label: NonNullable<unknown> }} Targetpreviewlabel2Inputs */
/** @typedef {{}} Targetpreviewunavailable2Inputs */
/** @typedef {{}} Targetresumeaction2Inputs */
/** @typedef {{}} Targetselectlabel2Inputs */
/** @typedef {{}} Targettilemenulabel3Inputs */
/** @typedef {{}} Targetwipbadge2Inputs */
/** @typedef {{}} Teachbrowserdiscard2Inputs */
/** @typedef {{}} Teachbrowseropenviewer3Inputs */
/** @typedef {{}} Teachbrowserpromote2Inputs */
/** @typedef {{}} Teachbrowserready2Inputs */
/** @typedef {{}} Teachbrowserrecording2Inputs */
/** @typedef {{}} Teachbrowsershowpath3Inputs */
/** @typedef {{}} Teachbrowserstop2Inputs */
/** @typedef {{}} Teachbrowsersummary2Inputs */
/** @typedef {{}} Technicaldetails1Inputs */
/** @typedef {{}} Unknowncreator1Inputs */
/** @typedef {{}} Unpinfavorite1Inputs */
/** @typedef {{}} Untitledconversation1Inputs */
/** @typedef {{}} Updatemergerequest2Inputs */
/** @typedef {{}} Websitesectionempty2Inputs */
/** @typedef {{}} Websitesectionlabel2Inputs */
/** @typedef {{}} Youname1Inputs */


export const abandonsession1 = /** @type {(inputs: Abandonsession1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

export const abandonsessioncancel2 = /** @type {(inputs: Abandonsessioncancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

export const abandonsessionconfirm2 = /** @type {(inputs: Abandonsessionconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cette conversation ? L’aperçu, la branche Git et tout l’historique associé seront définitivement effacés.`)
};

export const abandonsessionconfirmaction3 = /** @type {(inputs: Abandonsessionconfirmaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

export const accountaccessdenied2 = /** @type {(inputs: Accountaccessdenied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre compte ne dispose d’aucun accès au studio.`)
};

export const agentbusy1 = /** @type {(inputs: Agentbusy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un traitement est déjà en cours sur cette conversation.`)
};

export const agenthostbusymany3 = /** @type {(inputs: Agenthostbusymany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L’agent est occupé sur ${i?.count} autres conversations. Votre demande pourra patienter.`)
};

export const agenthostbusyone3 = /** @type {(inputs: Agenthostbusyone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’agent est occupé sur 1 autre conversation. Votre demande pourra patienter.`)
};

export const agentmodel1 = /** @type {(inputs: Agentmodel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle`)
};

export const agentmodelhint2 = /** @type {(inputs: Agentmodelhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle utilisé pour les prochains messages`)
};

export const agentname1 = /** @type {(inputs: Agentname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant`)
};

export const agentstatus1 = /** @type {(inputs: Agentstatus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étape`)
};

export const agentthinking1 = /** @type {(inputs: Agentthinking1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réflexion`)
};

export const agentworking1 = /** @type {(inputs: Agentworking1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement en cours…`)
};

export const apicallfailed2 = /** @type {(inputs: Apicallfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue. Réessayez dans un instant.`)
};

export const apiunreachable1 = /** @type {(inputs: Apiunreachable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le studio est momentanément indisponible. Réessayez dans un instant.`)
};

export const appssectionlabel2 = /** @type {(inputs: Appssectionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps`)
};

export const attachfiles1 = /** @type {(inputs: Attachfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joindre un fichier`)
};

export const automationscanceledit2 = /** @type {(inputs: Automationscanceledit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

export const automationscreate1 = /** @type {(inputs: Automationscreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer`)
};

export const automationscreateheading2 = /** @type {(inputs: Automationscreateheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle automatisation`)
};

export const automationsdelete1 = /** @type {(inputs: Automationsdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

export const automationsdisable1 = /** @type {(inputs: Automationsdisable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver`)
};

export const automationsdisabled1 = /** @type {(inputs: Automationsdisabled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`désactivée`)
};

export const automationsedit1 = /** @type {(inputs: Automationsedit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

export const automationsempty1 = /** @type {(inputs: Automationsempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune automatisation pour le moment.`)
};

export const automationsenable1 = /** @type {(inputs: Automationsenable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer`)
};

export const automationsenabled1 = /** @type {(inputs: Automationsenabled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`activée`)
};

export const automationsfieldcron2 = /** @type {(inputs: Automationsfieldcron2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planification (cron)`)
};

export const automationsfieldparentsession3 = /** @type {(inputs: Automationsfieldparentsession3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation parente`)
};

export const automationsfieldprompt2 = /** @type {(inputs: Automationsfieldprompt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions`)
};

export const automationsfieldproposemr3 = /** @type {(inputs: Automationsfieldproposemr3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposer une merge request après exécution`)
};

export const automationsfieldtitle2 = /** @type {(inputs: Automationsfieldtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre`)
};

export const automationsgroupsheading2 = /** @type {(inputs: Automationsgroupsheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par conversation`)
};

export const automationslatestrun2 = /** @type {(inputs: Automationslatestrun2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernier run (${i?.status}) : ${i?.summary}`)
};

export const automationslead1 = /** @type {(inputs: Automationslead1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recettes planifiées liées à une conversation Studio. Chaque exécution hérite de la cible de la session parente.`)
};

export const automationsnav1 = /** @type {(inputs: Automationsnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisations`)
};

export const automationsnoparentsessions3 = /** @type {(inputs: Automationsnoparentsessions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune conversation disponible`)
};

export const automationsopensession2 = /** @type {(inputs: Automationsopensession2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir la conversation`)
};

export const automationsreadonly2 = /** @type {(inputs: Automationsreadonly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultation seule — vous n’avez pas le droit de gérer les automatisations.`)
};

export const automationsrunnow2 = /** @type {(inputs: Automationsrunnow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer`)
};

export const automationssave1 = /** @type {(inputs: Automationssave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

export const automationstitle1 = /** @type {(inputs: Automationstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisations`)
};

export const brandlogoalt2 = /** @type {(inputs: Brandlogoalt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimcar`)
};

export const browserlivepreview2 = /** @type {(inputs: Browserlivepreview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigateur`)
};

export const browserlivepreviewalt3 = /** @type {(inputs: Browserlivepreviewalt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu live du navigateur piloté par l’agent`)
};

export const browserlivepreviewhide3 = /** @type {(inputs: Browserlivepreviewhide3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer`)
};

export const browserlivepreviewshow3 = /** @type {(inputs: Browserlivepreviewshow3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le navigateur`)
};

export const capturepreview1 = /** @type {(inputs: Capturepreview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capturer l’aperçu`)
};

export const capturepreviewfailed2 = /** @type {(inputs: Capturepreviewfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de capturer l’aperçu.`)
};

export const capturepreviewhint2 = /** @type {(inputs: Capturepreviewhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capture tout l’aperçu (sans partage d’écran).`)
};

export const capturepreviewunavailable2 = /** @type {(inputs: Capturepreviewunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La capture d’aperçu n’est pas disponible pour le moment.`)
};

export const captureselectionhint2 = /** @type {(inputs: Captureselectionhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capture l’élément sélectionné avec la croix (sans partage d’écran).`)
};

export const captureselectionunavailable2 = /** @type {(inputs: Captureselectionunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resélectionnez l’élément avec la croix, puis réessayez la capture.`)
};

export const changetarget1 = /** @type {(inputs: Changetarget1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer d’application`)
};

export const chatregion1 = /** @type {(inputs: Chatregion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation`)
};

export const chattitle1 = /** @type {(inputs: Chattitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation`)
};

export const closeconversationhistory2 = /** @type {(inputs: Closeconversationhistory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer l’historique`)
};

export const collapsechat1 = /** @type {(inputs: Collapsechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replier la conversation`)
};

export const collapseconversationrail2 = /** @type {(inputs: Collapseconversationrail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replier la liste des conversations`)
};

export const continuelastappaction3 = /** @type {(inputs: Continuelastappaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

export const continuelastappbadge3 = /** @type {(inputs: Continuelastappbadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière app`)
};

export const continuelastappdescription3 = /** @type {(inputs: Continuelastappdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprendre votre dernière application indépendante.`)
};

export const continuelastappsectionlabel4 = /** @type {(inputs: Continuelastappsectionlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

export const conversationhistory1 = /** @type {(inputs: Conversationhistory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique des conversations`)
};

export const conversationhistoryempty2 = /** @type {(inputs: Conversationhistoryempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune conversation pour le moment.`)
};

export const conversationrail1 = /** @type {(inputs: Conversationrail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

export const conversationrailmineempty3 = /** @type {(inputs: Conversationrailmineempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune de vos conversations pour le moment.`)
};

export const conversationrailshowall3 = /** @type {(inputs: Conversationrailshowall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher toutes les conversations`)
};

export const conversationrailshowmine3 = /** @type {(inputs: Conversationrailshowmine3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher uniquement les miennes`)
};

export const copylink1 = /** @type {(inputs: Copylink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le lien`)
};

export const defaultindependentappaction3 = /** @type {(inputs: Defaultindependentappaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer ici`)
};

export const defaultindependentappbadge3 = /** @type {(inputs: Defaultindependentappbadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour débuter`)
};

export const deletescratchappaction3 = /** @type {(inputs: Deletescratchappaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

export const deletescratchappcancel3 = /** @type {(inputs: Deletescratchappcancel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

export const deletescratchappconfirmaction4 = /** @type {(inputs: Deletescratchappconfirmaction4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l’app`)
};

export const deletescratchappconfirmlead4 = /** @type {(inputs: Deletescratchappconfirmlead4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`« ${i?.label} » et ses conversations seront retirées de l’atelier. Les apps déployées et les projets GitLab ne sont pas supprimés ici.`)
};

export const deletescratchappconfirmtitle4 = /** @type {(inputs: Deletescratchappconfirmtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cette app indépendante ?`)
};

export const deletescratchappworking3 = /** @type {(inputs: Deletescratchappworking3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression…`)
};

export const deploycancelaction2 = /** @type {(inputs: Deploycancelaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

export const deployconfirmaction2 = /** @type {(inputs: Deployconfirmaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer le déploiement`)
};

export const deploymodedialogtitle3 = /** @type {(inputs: Deploymodedialogtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment déployer ?`)
};

export const deploymodenewapp3 = /** @type {(inputs: Deploymodenewapp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déployer sous un nouvel identifiant`)
};

export const deploymodereplaceparent3 = /** @type {(inputs: Deploymodereplaceparent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour l’app déjà déployée`)
};

export const deploymodethisapp3 = /** @type {(inputs: Deploymodethisapp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déployer cette application`)
};

export const deploynewsluglabel3 = /** @type {(inputs: Deploynewsluglabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de l’app (URL)`)
};

export const deploynewslugplaceholder3 = /** @type {(inputs: Deploynewslugplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ma-nouvelle-app`)
};

export const deploypublicurlhint3 = /** @type {(inputs: Deploypublicurlhint3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`URL publique : ${i?.url}`)
};

export const deploysessionaction2 = /** @type {(inputs: Deploysessionaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déployer`)
};

export const deploysessionsucceeded2 = /** @type {(inputs: Deploysessionsucceeded2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Application déployée : ${i?.hostname}`)
};

export const deploysessionworking2 = /** @type {(inputs: Deploysessionworking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déploiement en cours…`)
};

export const deploysluginvalidhint3 = /** @type {(inputs: Deploysluginvalidhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant invalide (minuscules, chiffres, tirets).`)
};

export const deployslugreservedhint3 = /** @type {(inputs: Deployslugreservedhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant réservé (mktp, web, scratch, studio, p…).`)
};

export const deployslugtakenhint3 = /** @type {(inputs: Deployslugtakenhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet identifiant est déjà utilisé par une app déployée.`)
};

export const deployedappeditaction3 = /** @type {(inputs: Deployedappeditaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

export const deployedappopenaction3 = /** @type {(inputs: Deployedappopenaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir`)
};

export const deployedapprevertaction3 = /** @type {(inputs: Deployedapprevertaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenir à…`)
};

export const deployedapprevertcancel3 = /** @type {(inputs: Deployedapprevertcancel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

export const deployedapprevertconfirm3 = /** @type {(inputs: Deployedapprevertconfirm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurer cette version`)
};

export const deployedapprevertdialogtitle4 = /** @type {(inputs: Deployedapprevertdialogtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenir à une version déployée`)
};

export const deployedapprevertempty3 = /** @type {(inputs: Deployedapprevertempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun historique de déploiement disponible.`)
};

export const deployedapprevertworking3 = /** @type {(inputs: Deployedapprevertworking3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restauration en cours…`)
};

export const deployedappstopaction3 = /** @type {(inputs: Deployedappstopaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter`)
};

export const deployedappsempty2 = /** @type {(inputs: Deployedappsempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune application déployée pour le moment.`)
};

export const deployedappssectionlabel3 = /** @type {(inputs: Deployedappssectionlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps déployées`)
};

export const dictatemessage1 = /** @type {(inputs: Dictatemessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicter le message`)
};

export const dictationunsupported1 = /** @type {(inputs: Dictationunsupported1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dictée n’est pas disponible dans ce navigateur.`)
};

export const downloadattachment1 = /** @type {(inputs: Downloadattachment1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Télécharger ${i?.fileName}`)
};

export const expandchat1 = /** @type {(inputs: Expandchat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir la conversation`)
};

export const expandconversationrail2 = /** @type {(inputs: Expandconversationrail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher la liste des conversations`)
};

export const favoritebadge1 = /** @type {(inputs: Favoritebadge1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favori`)
};

export const favoriteopenaction2 = /** @type {(inputs: Favoriteopenaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir`)
};

export const favoritesempty1 = /** @type {(inputs: Favoritesempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune conversation en favori pour le moment.`)
};

export const favoritessectionlabel2 = /** @type {(inputs: Favoritessectionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoris`)
};

export const homelead1 = /** @type {(inputs: Homelead1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez ce que vous souhaitez changer. Chaque envoi ouvre une conversation dédiée, visible par toute l’équipe du studio.`)
};

export const identityproviderunavailable2 = /** @type {(inputs: Identityproviderunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le service de connexion est momentanément indisponible. Veuillez réessayer ultérieurement.`)
};

export const independentappssectionempty3 = /** @type {(inputs: Independentappssectionempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune application indépendante pour le moment.`)
};

export const independentappssectionlabel3 = /** @type {(inputs: Independentappssectionlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apps indépendantes`)
};

export const inspecthint1 = /** @type {(inputs: Inspecthint1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez un élément dans l’aperçu.`)
};

export const inspectselectionwithkey3 = /** @type {(inputs: Inspectselectionwithkey3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- UI sélectionnée : messageKey=${i?.messageKey}${i?.filePart}${i?.textPart}`)
};

export const inspectselectionsheader2 = /** @type {(inputs: Inspectselectionsheader2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éléments UI sélectionnés :`)
};

export const linkcopied1 = /** @type {(inputs: Linkcopied1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien copié`)
};

export const lintfailed1 = /** @type {(inputs: Lintfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d’envoyer la proposition pour le moment : la vérification automatique n’est pas passée. Demandez à l’assistant de corriger, puis réessayez.`)
};

export const loadingsession1 = /** @type {(inputs: Loadingsession1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouverture de votre espace…`)
};

export const login = /** @type {(inputs: LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

export const logininstructions1 = /** @type {(inputs: Logininstructions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous avec votre compte Stimcar pour accéder au studio.`)
};

export const logintitle1 = /** @type {(inputs: Logintitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

export const maximizechat1 = /** @type {(inputs: Maximizechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrandir la conversation`)
};

export const mergerequestopened2 = /** @type {(inputs: Mergerequestopened2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposition envoyée pour validation`)
};

export const mergerequestupdated2 = /** @type {(inputs: Mergerequestupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposition mise à jour`)
};

export const messageplaceholder1 = /** @type {(inputs: Messageplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez ce que vous souhaitez…`)
};

export const missingrootelement2 = /** @type {(inputs: Missingrootelement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élément introuvable`)
};

export const newconversation1 = /** @type {(inputs: Newconversation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle conversation`)
};

export const newscratchappaction3 = /** @type {(inputs: Newscratchappaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer`)
};

export const newscratchappcancel3 = /** @type {(inputs: Newscratchappcancel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

export const newscratchappcreating3 = /** @type {(inputs: Newscratchappcreating3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création de l’application…`)
};

export const newscratchappdescription3 = /** @type {(inputs: Newscratchappdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une application partagée, puis travailler dessus en session.`)
};

export const newscratchapplabel3 = /** @type {(inputs: Newscratchapplabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle app`)
};

export const newscratchappnamelabel4 = /** @type {(inputs: Newscratchappnamelabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de l’application`)
};

export const newscratchappnameplaceholder4 = /** @type {(inputs: Newscratchappnameplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanbans en retard`)
};

export const newscratchappslughint4 = /** @type {(inputs: Newscratchappslughint4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Identifiant : ${i?.slug}`)
};

export const newscratchappsluginvalid4 = /** @type {(inputs: Newscratchappsluginvalid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indiquez un nom qui donne un identifiant valide (lettres, chiffres, tirets).`)
};

export const openmergerequest2 = /** @type {(inputs: Openmergerequest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposer les changements`)
};

export const openspecarchivemergerequestopened4 = /** @type {(inputs: Openspecarchivemergerequestopened4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposition OpenSpec sync/archive`)
};

export const pagetitle1 = /** @type {(inputs: Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const pinfavorite1 = /** @type {(inputs: Pinfavorite1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter aux favoris`)
};

export const previewdevicedesktop2 = /** @type {(inputs: Previewdevicedesktop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bureau`)
};

export const previewdevicemobile2 = /** @type {(inputs: Previewdevicemobile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

export const previewdeviceswitch2 = /** @type {(inputs: Previewdeviceswitch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille d’affichage de l’aperçu`)
};

export const previewdevicetablet2 = /** @type {(inputs: Previewdevicetablet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tablette`)
};

export const previewoff1 = /** @type {(inputs: Previewoff1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’aperçu de cette conversation n’est pas disponible pour le moment.`)
};

export const previewpathapply2 = /** @type {(inputs: Previewpathapply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller`)
};

export const previewpathback2 = /** @type {(inputs: Previewpathback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page précédente`)
};

export const previewpathforward2 = /** @type {(inputs: Previewpathforward2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page suivante`)
};

export const previewpathinvalid2 = /** @type {(inputs: Previewpathinvalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur : chemin invalide.`)
};

export const previewpathlabel2 = /** @type {(inputs: Previewpathlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemin de l’aperçu`)
};

export const previewpathofforigin3 = /** @type {(inputs: Previewpathofforigin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur : cette adresse n’appartient pas à l’origine de l’aperçu.`)
};

export const previewpathpresetcatalogue3 = /** @type {(inputs: Previewpathpresetcatalogue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogue`)
};

export const previewpathpresetdiaporama3 = /** @type {(inputs: Previewpathpresetdiaporama3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diaporama`)
};

export const previewpathpresethome3 = /** @type {(inputs: Previewpathpresethome3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accueil`)
};

export const previewpathpresets2 = /** @type {(inputs: Previewpathpresets2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemins rapides`)
};

export const previewregion1 = /** @type {(inputs: Previewregion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu`)
};

export const previewrestoring1 = /** @type {(inputs: Previewrestoring1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation de l’aperçu…`)
};

export const promptactivityclose2 = /** @type {(inputs: Promptactivityclose2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer le journal`)
};

export const promptactivityempty2 = /** @type {(inputs: Promptactivityempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun prompt récent.`)
};

export const promptactivitylead2 = /** @type {(inputs: Promptactivitylead2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derniers tours agent lancés sur ce studio.`)
};

export const promptactivityloadfailed3 = /** @type {(inputs: Promptactivityloadfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger le journal.`)
};

export const promptactivitytitle2 = /** @type {(inputs: Promptactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompts récents`)
};

export const promptactivityuntitled2 = /** @type {(inputs: Promptactivityuntitled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(sans titre)`)
};

export const quickstartaction2 = /** @type {(inputs: Quickstartaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

export const quickstartlabel2 = /** @type {(inputs: Quickstartlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre demande`)
};

export const quickstartnostartertarget4 = /** @type {(inputs: Quickstartnostartertarget4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’application de démarrage n’est pas encore disponible. Réessayez dans un instant ou créez une nouvelle app.`)
};

export const quickstartplaceholder2 = /** @type {(inputs: Quickstartplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posez votre question ou décrivez ce que vous voulez créer…`)
};

export const quickstartworking2 = /** @type {(inputs: Quickstartworking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création de la conversation…`)
};

export const redeploysessionaction2 = /** @type {(inputs: Redeploysessionaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour le déploiement`)
};

export const removeattachment1 = /** @type {(inputs: Removeattachment1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirer ${i?.fileName}`)
};

export const removeselection1 = /** @type {(inputs: Removeselection1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirer ${i?.label}`)
};

export const renameconversation1 = /** @type {(inputs: Renameconversation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renommer la conversation`)
};

export const requestrequired1 = /** @type {(inputs: Requestrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez ce que vous souhaitez avant de continuer.`)
};

export const resizechat1 = /** @type {(inputs: Resizechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner la conversation`)
};

export const restorechat1 = /** @type {(inputs: Restorechat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduire la conversation`)
};

export const saveconversationtitle2 = /** @type {(inputs: Saveconversationtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le titre`)
};

export const securespace1 = /** @type {(inputs: Securespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espace sécurisé`)
};

export const selectcomponent1 = /** @type {(inputs: Selectcomponent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner un élément`)
};

export const sendmessage1 = /** @type {(inputs: Sendmessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

export const servicetemporarilyunavailable2 = /** @type {(inputs: Servicetemporarilyunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le service est momentanément indisponible.`)
};

export const sessionaccessdenied2 = /** @type {(inputs: Sessionaccessdenied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n’avez pas accès à cette conversation.`)
};

export const sessionaccessdeniedlead3 = /** @type {(inputs: Sessionaccessdeniedlead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demandez au créateur de la partager ou de la rendre ouverte.`)
};

export const sessionloading1 = /** @type {(inputs: Sessionloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la conversation…`)
};

export const sessionmakeopen2 = /** @type {(inputs: Sessionmakeopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendre ouverte`)
};

export const sessionmakeprivate2 = /** @type {(inputs: Sessionmakeprivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendre privée`)
};

export const sessionmissing1 = /** @type {(inputs: Sessionmissing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation introuvable.`)
};

export const sessionpublishmenu2 = /** @type {(inputs: Sessionpublishmenu2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier`)
};

export const sessionshareadd2 = /** @type {(inputs: Sessionshareadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter`)
};

export const sessionshareemailplaceholder3 = /** @type {(inputs: Sessionshareemailplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-mail à inviter`)
};

export const sessionsharedwithyou3 = /** @type {(inputs: Sessionsharedwithyou3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette conversation vous a été partagée.`)
};

export const sessionsharing1 = /** @type {(inputs: Sessionsharing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partage de la conversation`)
};

export const sessionunshare1 = /** @type {(inputs: Sessionunshare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer`)
};

export const sessionunshareemail2 = /** @type {(inputs: Sessionunshareemail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirer ${i?.email}`)
};

export const sessionvisibilityopen2 = /** @type {(inputs: Sessionvisibilityopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouverte`)
};

export const sessionvisibilityprivate2 = /** @type {(inputs: Sessionvisibilityprivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privée`)
};

export const settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglages`)
};

export const settingsclose1 = /** @type {(inputs: Settingsclose1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

export const settingscreateappheading3 = /** @type {(inputs: Settingscreateappheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création d’applications`)
};

export const settingscreateapplead3 = /** @type {(inputs: Settingscreateapplead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand cette option est activée, le menu de création d’une application indépendante apparaît sur l’écran des applications (si votre compte en a la permission).`)
};

export const settingscreateappsubtitle3 = /** @type {(inputs: Settingscreateappsubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu expérimental sur l’écran des applications`)
};

export const settingscreateapptoggle3 = /** @type {(inputs: Settingscreateapptoggle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher « Nouvelle app »`)
};

export const settingsdeleteappheading3 = /** @type {(inputs: Settingsdeleteappheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression d’applications`)
};

export const settingsdeleteapplead3 = /** @type {(inputs: Settingsdeleteapplead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand cette option est activée, une action Supprimer apparaît sur les tuiles Apps indépendantes (si votre compte peut créer des apps). Les apps déployées doivent d’abord être arrêtées. L’app starter par défaut ne peut pas être supprimée.`)
};

export const settingsdeleteappsubtitle3 = /** @type {(inputs: Settingsdeleteappsubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions destructives sur les apps indépendantes`)
};

export const settingsdeleteapptoggle3 = /** @type {(inputs: Settingsdeleteapptoggle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher « Supprimer » sur les apps indépendantes`)
};

export const settingseyebrow1 = /** @type {(inputs: Settingseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const settingspreviewpathbarheading4 = /** @type {(inputs: Settingspreviewpathbarheading4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation de l’aperçu`)
};

export const settingspreviewpathbarlead4 = /** @type {(inputs: Settingspreviewpathbarlead4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiche la barre d’adresse et les raccourcis (catalogue, diaporama…) en haut de l’aperçu.`)
};

export const settingspreviewpathbarsubtitle4 = /** @type {(inputs: Settingspreviewpathbarsubtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barre d’adresse et raccourcis (catalogue, diaporama…)`)
};

export const settingspreviewpathbartoggle4 = /** @type {(inputs: Settingspreviewpathbartoggle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher la barre de navigation de l’aperçu`)
};

export const settingspromptactivityheading3 = /** @type {(inputs: Settingspromptactivityheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal des prompts`)
};

export const settingspromptactivitylead3 = /** @type {(inputs: Settingspromptactivitylead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvre une fenêtre listant les derniers prompts lancés sur ce studio (e-mail, heure, conversation). Utile avant un redémarrage ou une mise à jour.`)
};

export const settingspromptactivitysubtitle3 = /** @type {(inputs: Settingspromptactivitysubtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qui a lancé un prompt, et quand`)
};

export const settingspromptactivitytoggle3 = /** @type {(inputs: Settingspromptactivitytoggle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le journal des prompts`)
};

export const settingstitle1 = /** @type {(inputs: Settingstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglages`)
};

export const sourceconnectaction2 = /** @type {(inputs: Sourceconnectaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

export const sourceconnectconnecting2 = /** @type {(inputs: Sourceconnectconnecting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion ouverte`)
};

export const sourceconnectopenviewer3 = /** @type {(inputs: Sourceconnectopenviewer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le navigateur`)
};

export const sourceconnectskip2 = /** @type {(inputs: Sourceconnectskip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer`)
};

export const sourceconnecttitle2 = /** @type {(inputs: Sourceconnecttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources navigateur`)
};

export const startpreview1 = /** @type {(inputs: Startpreview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher l’aperçu`)
};

export const startsectionlabel2 = /** @type {(inputs: Startsectionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer`)
};

export const startsectionlead2 = /** @type {(inputs: Startsectionlead2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez ce que vous voulez. On ouvre une session sur l’application de démarrage.`)
};

export const startsectiontitle2 = /** @type {(inputs: Startsectiontitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment puis-je vous aider ?`)
};

export const startingrequest1 = /** @type {(inputs: Startingrequest1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création de la conversation…`)
};

export const stopdictation1 = /** @type {(inputs: Stopdictation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter la dictée`)
};

export const stopselectingcomponent2 = /** @type {(inputs: Stopselectingcomponent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter la sélection`)
};

export const stopturn1 = /** @type {(inputs: Stopturn1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter le traitement`)
};

export const studioname1 = /** @type {(inputs: Studioname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const studiowelcomeeyebrow2 = /** @type {(inputs: Studiowelcomeeyebrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

export const studiowelcometitleattack3 = /** @type {(inputs: Studiowelcometitleattack3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`On s’attaque à quoi, ${i?.name} ?`)
};

export const studiowelcometitleembellish3 = /** @type {(inputs: Studiowelcometitleembellish3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quelle app on embellit, ${i?.name} ?`)
};

export const studiowelcometitlehello3 = /** @type {(inputs: Studiowelcometitlehello3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bonjour ${i?.name}, on part sur quoi aujourd’hui ?`)
};

export const studiowelcometitleidea3 = /** @type {(inputs: Studiowelcometitleidea3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, une idée à faire vivre ?`)
};

export const studiowelcometitleimprove3 = /** @type {(inputs: Studiowelcometitleimprove3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Que souhaitez-vous améliorer, ${i?.name} ?`)
};

export const syncsessionbase2 = /** @type {(inputs: Syncsessionbase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour sur la dernière base de code`)
};

export const targetopenaction2 = /** @type {(inputs: Targetopenaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer`)
};

export const targetpickerempty2 = /** @type {(inputs: Targetpickerempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune application enregistrée pour le moment.`)
};

export const targetpickerlead2 = /** @type {(inputs: Targetpickerlead2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez une idée pour démarrer, ou choisissez une application dans le menu.`)
};

export const targetpreviewlabel2 = /** @type {(inputs: Targetpreviewlabel2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aperçu de ${i?.label}`)
};

export const targetpreviewunavailable2 = /** @type {(inputs: Targetpreviewunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu indisponible`)
};

export const targetresumeaction2 = /** @type {(inputs: Targetresumeaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprendre`)
};

export const targetselectlabel2 = /** @type {(inputs: Targetselectlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application à modifier`)
};

export const targettilemenulabel3 = /** @type {(inputs: Targettilemenulabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

export const targetwipbadge2 = /** @type {(inputs: Targetwipbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

export const teachbrowserdiscard2 = /** @type {(inputs: Teachbrowserdiscard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeter le brouillon`)
};

export const teachbrowseropenviewer3 = /** @type {(inputs: Teachbrowseropenviewer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le navigateur`)
};

export const teachbrowserpromote2 = /** @type {(inputs: Teachbrowserpromote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promouvoir le skill`)
};

export const teachbrowserready2 = /** @type {(inputs: Teachbrowserready2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon de skill prêt`)
};

export const teachbrowserrecording2 = /** @type {(inputs: Teachbrowserrecording2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement — montrez le parcours dans le viewer`)
};

export const teachbrowsershowpath3 = /** @type {(inputs: Teachbrowsershowpath3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montrer le parcours`)
};

export const teachbrowserstop2 = /** @type {(inputs: Teachbrowserstop2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter l’enseignement`)
};

export const teachbrowsersummary2 = /** @type {(inputs: Teachbrowsersummary2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résumé de l’enseignement`)
};

export const technicaldetails1 = /** @type {(inputs: Technicaldetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails techniques`)
};

export const unknowncreator1 = /** @type {(inputs: Unknowncreator1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur inconnu`)
};

export const unpinfavorite1 = /** @type {(inputs: Unpinfavorite1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer des favoris`)
};

export const untitledconversation1 = /** @type {(inputs: Untitledconversation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle conversation`)
};

export const updatemergerequest2 = /** @type {(inputs: Updatemergerequest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour la proposition`)
};

export const websitesectionempty2 = /** @type {(inputs: Websitesectionempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun site web enregistré pour le moment.`)
};

export const websitesectionlabel2 = /** @type {(inputs: Websitesectionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site web`)
};

export const youname1 = /** @type {(inputs: Youname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous`)
};